import React, { useState, useEffect } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import GetInTouchSide from "./GetInTouchSide";
import axiosStrapiInstance from "../axiosStrapi";
import CustomContent from "./custom/CustomContent";

export default function Faq() {
  window.scrollTo(0, 20);
  const [openIndex, setOpenIndex] = useState(0);
  const [faqItems, setFaqs] = useState([]);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosStrapiInstance.get("/api/faqs?populate=*");
        const result = response?.data?.data?.filter(
          (item) => item?.type === "Dashboard"
        );
        setFaqs(result || []);
      } catch (error) {
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="flex lg:flex-row flex-col font-Lato h-[calc(100vh-88px)]">
      <div className="lg:w-[68%] border-r font-Lato  mx-auto pl-[5%] lg:pl-[10%] pr-[5%] py-[5%] ">
        <h2 className="text-[40px] leading-[48px] font-medium mb-8">
          <span className="text-black">FAQs</span>{" "}
        </h2>
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className={` transition-all py-4 duration-400  border-gray-500 ${
                openIndex === index
                  ? "bg-[#DB214C] text-white  rounded-xl"
                  : "border-b-[2px]"
              }`}
            >
              <button
                className="w-full px-3 text-left font-bold sm:font-normal text-base flex justify-between items-center"
                onClick={() => toggleFAQ(index)}
              >
                {item.Question}
                <span>
                  {openIndex === index ? (
                    <FaAngleUp className="" />
                  ) : (
                    <FaAngleDown className="text-red-900" />
                  )}
                </span>
              </button>
              {openIndex === index && (
                <CustomContent
                  text={item?.Answer}
                  padding="p-4"
                  textSize="16px"
                  leading="22px"
                  textColor="#374151"
                />
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="lg:w-[30%]">
        {" "}
        <GetInTouchSide />
      </div>
    </div>
  );
}
